import React from 'react'
import img3012 from '../components/images/salesflipkart.png'
import img3012a from '../components/images/salesflipkart1.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img3012} alt='meesho' />
            </div>
            <div className='container text-center'>
                <h2>Introduction To Flipkart Sale Boost</h2>
                <p>
                    At E Seller Support, we specialize in optimizing your Flipkart sales strategy with tailored services. Our focus is on enhancing visibility, increasing conversions, and fostering sustainable growth for your business on Flipkart. We achieve this through strategic ad placements, effective coupon management, targeted promotions, keyword optimization, and active participation in Flipkart’s events. Our goal is to ensure your products stand out and thrive in the competitive marketplace, leveraging Flipkart’s robust marketing tools for measurable success.
                </p>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <ol className="list-group-numbered">
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Advertisement:</div>
                                    Strategically place sponsored ads across Flipkart’s platform to significantly enhance product visibility and capture the attention of a broader audience, increasing brand exposure and driving traffic.
                                </div>

                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Promotion:</div>
                                    Craft and execute targeted promotional campaigns that spotlight your products, strategically timed to maximize sales during peak shopping seasons, festivals, and special events. These campaigns aim to boost visibility and attract more customers to your listings.
                                </div>
                            </li>
                            <li className="list-group-item d-flex justify-content-between align-items-start">
                                <div className="ms-2 me-auto">
                                    <div className="fw-bold">Keyword Optimization:</div>
                                    Optimize product listings with meticulous keyword strategies to improve search rankings, attract organic traffic, and resonate with potential customers actively searching for products similar to yours. Effective keyword optimization ensures your products are easily discoverable and appealing to the right audience.
                                </div>
                            </li>
                        </ol>
                    </div >
                    <div className='col'>
                        <img src={img3012a} alt='Queryimg' />
                    </div>
                </div>
                <p>Our comprehensive approach is designed to optimize your presence on Flipkart, driving sales growth and achieving measurable results in the competitive e-commerce marketplace.</p>
            </div>
        </>
    )
}

export default events